export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_00.6f762884.jpg";